/* eslint-disable no-process-env */
const version = process.env.VERSION;

module.exports = {
  version,
  storageKeys: {
    sso: 'sso-store',
  },
  api: {
    url: `/api/${version}`,
    endpoints: {
      auth: {
        login: 'auth/login',
        providers: 'auth/login/providers',
        remember: 'auth/remember-password',
        reset: 'auth/reset-password',
        referrer: 'auth/reset-password/:code/:refCode',
        loginWithProvider: 'auth/login/:name',
        tokenInfo: 'auth/tokeninfo',
        userSession: 'auth/user-session',
      },
      accounts: {
        list: {
          path: 'accounts/list',
          query: {
            scopes: null,
          },
        },
      },
      applications: {
        byName: 'applications/:name',
      },
      permissions: {
        scope: 'permissions/scope/:name',
        application: 'permissions/application/:name',
      },
      legacy: {
        rememberPassword: 'legacy/remember-password',
      },
    },
  },
  privacyPolicyURL: 'https://www.socialnative.com/privacy-policy/',
  requestDemoURL: 'https://www.socialnative.com/request-demo',
};
